import axios from 'axios';

/**
 * 下载后端返回的二进制文件（导出任务）。
 * 不走 request.js，避免响应拦截器把 blob 当成 JSON 解包。
 */
export async function downloadExcel(url, fallbackName = '导出数据.xlsx') {
  const token = localStorage.getItem('token') || '';
  const response = await axios.get(url, {
    responseType: 'blob',
    headers: token ? { 'X-Access-Token': token } : {},
    timeout: 120000,
  });
  const encodedName = response.headers['download-filename'];
  let fileName = fallbackName;
  if (encodedName) {
    try {
      fileName = decodeURIComponent(encodedName);
    } catch (e) {
      fileName = encodedName;
    }
  }
  const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(blobUrl);
}
